<template>
  <CommonIconLabel icon="MapPin" :size="size">
    <p class="label-localization">
      <a target="_blank" :href="`https://maps.google.com/?q=${localization}`">{{ localization }}</a>
      <ArrowUpRight :size="16" />
    </p>
  </CommonIconLabel>
</template>

<script setup lang="ts">
import CommonIconLabel from '@/components/common/CommonIconLabel.vue'
import { ArrowUpRight } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    localization: string
    size: 'small' | 'medium'
  }>(),
  {
    size: 'small'
  }
)
</script>

<style scoped>
.label-localization {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.label-localization > a {
  text-decoration: underline;
}
</style>
